import { Typography } from '@jouzen/ecom-components/v3/Typography';

interface NewsroomAccordionHeaderProps {
  readonly date: string | undefined;
  readonly headline: string | undefined;
}

export const NewsroomAccordionHeader = ({
  date,
  headline,
}: NewsroomAccordionHeaderProps) => {
  return (
    <div className="max-w-[80vw]" data-cy="newsroom-header-container">
      {date && (
        <Typography
          className="text-sm font-light text-gray-400"
          data-cy="newsroom-date"
        >
          {date}
        </Typography>
      )}
      {headline && (
        <Typography
          variant="h6"
          Element="h3"
          weight="normal"
          data-cy="newsroom-headline"
        >
          {headline}
        </Typography>
      )}
    </div>
  );
};
